import { FormattedMessage } from "react-intl";
import Checkbox from "app/pages/.shared/form/Checkbox";
import React from "react";
import PropTypes from "prop-types";

const PaymentTermsInput = ({
	field,
	cgvDocumentName,
	informationStandardForm,
	onBlur,
	showInformationStandardForm,
	brandDisplayName,
}) => {
	return (
		<Checkbox
			field={field}
			name="accept-terms"
			id="accept-terms"
			showIcon={true}
			isRequired={true}
			toggle={onBlur}
			data-cy="payment-terms-input"
		>
			<FormattedMessage
				values={{
					cgvLink: (
						<FormattedMessage id="general.cgv">
							{message => (
								<a
									className="relative-link"
									rel="noopener noreferrer"
									target="_blank"
									href={cgvDocumentName}
								>
									{message}
								</a>
							)}
						</FormattedMessage>
					),
					secondaryLink: showInformationStandardForm && (
						<FormattedMessage id="payment.form.info.standard.link">
							{message => (
								<a
									className="relative-link"
									rel="noopener noreferrer"
									target="_blank"
									href={informationStandardForm}
								>
									{message}
								</a>
							)}
						</FormattedMessage>
					),
					brandName: brandDisplayName,
				}}
				id="payment.terms.label"
			/>
		</Checkbox>
	);
};

PaymentTermsInput.propTypes = {
	field: PropTypes.object,
	cgvDocumentName: PropTypes.string,
	informationStandardForm: PropTypes.string,
	onBlur: PropTypes.func,
	showInformationStandardForm: PropTypes.bool,
	brandDisplayName: PropTypes.string,
};

PaymentTermsInput.defaultProps = {
	field: {},
	onBlur: () => {},
};

export default PaymentTermsInput;
